import { render, staticRenderFns } from "./Popover.vue?vue&type=template&id=b98493b6&scoped=true"
import script from "./Popover.vue?vue&type=script&lang=js"
export * from "./Popover.vue?vue&type=script&lang=js"
import style0 from "./Popover.vue?vue&type=style&index=0&id=b98493b6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98493b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/examreg-client-prod-tc/exam-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b98493b6')) {
      api.createRecord('b98493b6', component.options)
    } else {
      api.reload('b98493b6', component.options)
    }
    module.hot.accept("./Popover.vue?vue&type=template&id=b98493b6&scoped=true", function () {
      api.rerender('b98493b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Popover.vue"
export default component.exports